import * as React from "react";
import { useParams } from "react-router-dom";
import { ToolEditor } from "@/components/tools/tool-editor";

export function AItools() {
  const { campaignId } = useParams();
  return campaignId ? <ToolEditor scope="campaigns" id={campaignId} /> : null;
}
